import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Box } from "@mui/material";
const Loader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000,
        width: "100%",
        height: "100vh",
        backgroundColor: "#0000007d",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{width:200,height:200}} >
        <DotLottieReact
          src="https://lottie.host/0a55e014-5ad5-4a30-b879-6dfd6dda57d7/CxKhrKWuVk.lottie"
          loop
          autoplay
        />
      </Box>
    </Box>
  );
};

export default Loader;
